'use client'

import * as React from 'react'
import Image from 'next/image'
import { Button } from '@repo/design-system-cf/components/button'
import { PAYMENT_ENTRY_POINTS } from 'payments/payments-dialog/analytics'
import { StartFreeTrialButton } from 'payments/start-free-trial-button'

export function DefaultHeroBannerContent({
  title,
  copy_1,
  copy_2,
  cta,
  cancel,
  showFreeTrialButton,
}: {
  title: string
  copy_1: string
  copy_2: string
  cta: string
  cancel: string
  showFreeTrialButton?: boolean
}) {
  const backgroundImage =
    'https://www.creativefabrica.com/wp-content/themes/creativefabricanew/v2.0/images/CF_homepage_banner.jpg'

  return (
    <div className="relative isolate hidden md:flex flex-col items-center justify-center px-5 py-20 w-full rounded-[12px] border border-[rgba(19,19,21,0.12)] overflow-hidden">
      <Image
        src={backgroundImage}
        fill
        alt="Creative Fabrica Homepage Banner"
        priority
        fetchPriority="high"
        sizes="(min-width: 1800px) 1800px, 100vw"
        className="object-cover z-[-1]"
      />
      <div className="relative flex flex-col items-center gap-2 text-center">
        <h1 className="text-cf-grey-1000 w-full text-center text-[40px] font-bold leading-[46px]">
          {title}
        </h1>
        <p className="text-cf-grey-800 w-full max-w-[1000px] text-[32px] font-medium leading-10">
          {copy_1}
        </p>
        <p className="text-16 text-cf-grey-600 font-medium">{copy_2}</p>
      </div>
      {showFreeTrialButton ? (
        <div className="relative flex items-center flex-col gap-2">
          <Button
            variant="primary-green-bright"
            size="large"
            className="mt-6 hover:text-cf-white"
            asChild
          >
            <StartFreeTrialButton
              entryPoint={PAYMENT_ENTRY_POINTS.HOMEPAGE_HERO_BANNER}
              label={cta}
            />
          </Button>
          <div className="font-bold">{cancel}</div>
        </div>
      ) : null}
    </div>
  )
}
